import type { SVGProps } from "react";
const SenecPictogramWorkZone = (props: Pick<SVGProps<SVGSVGElement>, "color">) => (
    <svg width={48} height={48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30.7574 35L32.7574 37H28.9001C28.4368 39.2822 26.419 41 24.0001 41C21.5811 41 19.5634 39.2822 19.1001 37H10.0001C8.89551 37 8.00008 36.1046 8.00008 35V33C8.00008 31.8954 8.89551 31 10.0001 31H11.0001V19C11.0001 17.8498 11.1494 16.7345 11.4299 15.6724L13.121 17.3635C13.0413 17.8975 13.0001 18.4439 13.0001 19V31H26.7574L28.7574 33H10.0001V35H30.7574ZM21.1708 37C21.5826 38.1652 22.6939 39 24.0001 39C25.3063 39 26.4175 38.1652 26.8294 37H21.1708Z"
            fill="currentColor"
        />
        <path
            d="M24.0001 6C20.2176 6 16.8124 7.61545 14.4368 10.194L15.8524 11.6097C17.8648 9.39237 20.7698 8 24.0001 8C30.0752 8 35.0001 12.9249 35.0001 19V30.7574L37.2427 33H38.0001V33.7574L39.8922 35.6495C39.9621 35.4459 40.0001 35.2274 40.0001 35V33C40.0001 31.8954 39.1046 31 38.0001 31H37.0001V19C37.0001 11.8203 31.1798 6 24.0001 6Z"
            fill="currentColor"
        />
        <path d="M6.29297 7.70711L40.293 41.7071L41.7072 40.2929L7.70718 6.29289L6.29297 7.70711Z" fill="currentColor" />
    </svg>
);
export default SenecPictogramWorkZone;
